import { render } from "./FinancialReeducation.vue?vue&type=template&id=07196c99&scoped=true&ts=true"
import script from "./FinancialReeducation.vue?vue&type=script&lang=ts"
export * from "./FinancialReeducation.vue?vue&type=script&lang=ts"

import "./FinancialReeducation.vue?vue&type=style&index=0&id=07196c99&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07196c99"]])

export default __exports__